import i18n from "../../../../constants/i18n";
import { ACCOUNTS_DELETION_HEADERS } from "../../../../constants/table-custom-headers/Communications";
import getAccountDeletionStore from "../../../../stores/communications-store/account-delete";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const AccountsDeletionData = withLiteObserverAndTheme(() => {
  const accountDeletionStore = getAccountDeletionStore();

  return (
    <Et3Table
      columns={ACCOUNTS_DELETION_HEADERS}
      rows={accountDeletionStore.accountDeletionsData.get()}
      title={i18n.get("ACCOUNTS_DELETION_DATA")}
      shouldBeFlagged={false}
      titleKey={"ACCOUNTS_DELETION_DATA"}
    />
  );
});
export default AccountsDeletionData;
